<template>
  <div v-if="coureurs.length > 0">
    <div class="select_fav">
      <b-button size="sm" class="button_select_fav inline-submenu-btn" v-for="(coureur, index) in coureurs" :key="index"
        @click="setSelected(index)" v-bind:class="{ favoris_selected: index === selected }"><img class="flag"
          :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" /> {{ coureur.dossard }} {{ coureur.nom
          }} {{ coureur.prenom }}</b-button>
    </div>

    <transition name="fade" v-if="runner_loaded && runner && !$store.state.loading">
      <b-row id="fiche_container">
        <b-col class="content_container d-flex flex-column gap-2">
          <Loading v-if="$store.state.loading"></Loading>
          <div class="d-flex flex-row flex-wrap gap-2 align-items-center justify-content-between">
            <EnteteCoureur :runner="runner"></EnteteCoureur>
            <CotationAndTracking :runner="runner"></CotationAndTracking>
          </div>

          <SubEnteteCoureur :runner="runner"></SubEnteteCoureur>
          <StatutCoureur :runner="runner"></StatutCoureur>
          <InfosPCCourseCoureur v-if="$store.getters['authAdmin/hasAdminRights']" :runner="runner">
          </InfosPCCourseCoureur>

          <EstimationPassagesCoureur :estimation="runner.estimation" :cote_itra="runner.identite.itra">
          </EstimationPassagesCoureur>
          <MapCoureur v-if="runner.lines && runner.lines.length > 0" :lines="runner.lines" :coureur="runner"
            :focus_point="focus_point">
          </MapCoureur>
          <ProfilCoureur v-if="runner.lines && runner.lines.length > 0" :lines="runner.lines" :coureur="runner"
            :focus_point="focus_point" v-on:focus_point="setFocusPoint"></ProfilCoureur>

          <div v-if="!runner_loaded && !$store.state.loading">
            <h3>{{ $t("fiche.erreur_chargement") }}</h3>
            <BackButton></BackButton>
          </div>
        </b-col>
      </b-row>
    </transition>

  </div>
</template>

<script>
import Runner from "@/classes/Runner/runner.class";
import axios from "axios";
import BackButton from "@/components/App/UI/BackButton.vue";
import EstimationPassagesCoureur from "@/components/FicheCoureur/EstimationPassagesCoureur.vue";
import MapCoureur from "@/components/FicheCoureur/MapCoureur.vue";
import ProfilCoureur from "@/components/FicheCoureur/ProfilCoureur.vue";
import Loading from "@/components/Loading.vue";
import EnteteCoureur from "@/components/FicheCoureur/EnteteCoureur.vue";
import CotationAndTracking from "@/components/FicheCoureur/CotationAndTracking.vue";
import StatutCoureur from "@/components/FicheCoureur/StatutCoureur.vue";
import SubEnteteCoureur from "@/components/FicheCoureur/SubEnteteCoureur.vue";
import InfosPCCourseCoureur from "@/components/FicheCoureur/InfosPCCourseCoureur.vue";

export default {
  components: {
    MapCoureur,
    ProfilCoureur,
    Loading,
    EstimationPassagesCoureur,
    BackButton,
    EnteteCoureur,
    CotationAndTracking,
    StatutCoureur,
    SubEnteteCoureur,
    InfosPCCourseCoureur,
  },
  props: ["favoris"],
  data() {
    return {
      coureurs: [],
      selected: 0,
      runner: null,
      runner_loaded: false,
      focus_point: 0,
    };
  },
  watch: {
    favoris() {
      this.fetchFavoris();
    },
  },
  methods: {
    setFocusPoint(p) {
      this.focus_point = p;
    },

    async fetchCoureurData() {
      if (!this.runner) {
        return;
      }
      const fetched = await this.runner.fetch();
      if (fetched) {
        this.runner_loaded = true;
      } else {
        this.runner_loaded = false;
      }
      this.$forceUpdate();
    },

    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchCoureurData();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },

    async loadFicheForSelected() {
      if (!this.coureurs.length || !this.coureurs[this.selected]) {
        this.runner = null;
        this.runner_loaded = false;
        return;
      }

      const id = this.coureurs[this.selected].id;
      if (id == null || id === "") {
        this.runner = null;
        this.runner_loaded = false;
        return;
      }

      this.focus_point = 0;
      this.$store.commit("setLoading");

      this.runner = new Runner(
        this.$store.state.module.id,
        id,
        this.$store.state.module.id_live
      );
      this.runner.setLoadAsPcCourse(this.$store.getters["authAdmin/hasAdminRights"]);
      this.runner_loaded = await this.runner.fetch();
      await this.runner.buildLines();

      this.$store.commit("unsetLoading");
      this.$forceUpdate();
    },

    removeFavoris() {
      this.$emit("removeFavoris", this.selected);
    },

    async setSelected(index) {
      this.selected = index;
      await this.loadFicheForSelected();
    },

    async fetchFavoris() {
      if (!this.favoris || this.favoris.length === 0) {
        this.coureurs = [];
        this.runner = null;
        this.runner_loaded = false;
        return;
      }

      const response = await axios.post(this.$store.state.base_url + "/live/favoris/get.php", {
        list_favoris: JSON.stringify(this.favoris),
        id_live: this.$store.state.module.id_live,
        id_module: this.$store.state.module.id,
      });

      this.coureurs = response.data || [];
      if (this.selected >= this.coureurs.length) {
        this.selected = 0;
      }

      if (!this.coureurs.length) {
        this.runner = null;
        this.runner_loaded = false;
        return;
      }

      await this.loadFicheForSelected();
    },
  },
  async mounted() {
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
    await this.fetchFavoris();
    this.countdownRefresh();
    this.$forceUpdate();
  },
  beforeDestroy() {
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
  },
};
</script>

<style lang="scss" scoped></style>
